module.exports = __webpack_public_path__ + "static/media/sass.56cd4b21.png";